module.exports = "<svg viewBox=\"0 0 299.2 110.9\"><path d=\"M100.2 7.5L86.8 21l25 25H.4v19h111.4l-25 25 13.4 13.4 47.9-47.9-47.9-48z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-arrow.svg
// module id = 281
// module chunks = 1